import PropTypes from 'prop-types';

import React from 'react';

import EditableTextField from './../../components/forms/editableTextField.jsx';

import EditableDatePicker from './../../components/forms/editableDatePicker.jsx';
import {FormattedMessage} from 'react-intl';

class SystemDetails extends React.Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    editMode: PropTypes.bool.isRequired,
    equipment: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    types: PropTypes.array.isRequired,
  };

  deleteEquipment = () => {
    if (this.props.onDelete) {
      this.props.onDelete();
    }
  };

  handleChange = (e) => {
    let equip = this.props.equipment;

    equip[e.key] = e.value;
    if (this.props.onChange) {
      this.props.onChange({key: this.props.dataKey, value: equip});
    }
  };

  render() {
    let typeName = this.props.equipment && this.props.types ?
      this.props.types.filter(t => t.id === this.props.equipment.typeID)[0].name :
      null;

    return <div>
      <div className='row'>
        <div className='col-xs-1'>
          <label><FormattedMessage id='general.type'/></label>
        </div>

        <div className='col-xs-1'>
          <label><FormattedMessage id='general.make'/></label>
        </div>

        <div className='col-xs-2'>
          <label><FormattedMessage id='system.details.last.service'/></label>
        </div>

        <div className='col-xs-2'>
          <label><FormattedMessage id='system.details.planned.service'/></label>
        </div>

        <div className='col-xs-1'>
          <label><FormattedMessage id='system.details.serial.number'/></label>
        </div>
        <div className='col-xs-2'>
          <label><FormattedMessage id='system.details.warranty.date'/></label>
        </div>
        <div className='col-xs-2'>
          <label><FormattedMessage id='system.details.installation.date'/></label>
        </div>

        <div className='col-xs-1'>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-1'>
          <div className='form-control-static'>{typeName}</div>
        </div>

        <div className='col-xs-1'>
          <EditableTextField
            editMode={this.props.editMode}
            onChange={this.handleChange}
            value={this.props.equipment.make}
            dataKey='make'
            nullText='(none)'/>
        </div>

        <div className='col-xs-2'>
          <EditableDatePicker
            onChange={this.handleChange}
            value={this.props.equipment.lastService}
            dataKey='lastService'
            dateFormat='D MMMM YYYY'
            editMode={this.props.editMode}/>
        </div>

        <div className='col-xs-2'>
          <EditableDatePicker
            onChange={this.handleChange}
            value={this.props.equipment.nextService}
            dataKey='nextService'
            dateFormat='D MMMM YYYY'
            editMode={this.props.editMode}/>
        </div>

        <div className='col-xs-1'>
          <EditableTextField class='attribute-text'
                             editMode={this.props.editMode}
                             onChange={this.handleChange}
                             value={this.props.equipment.serialNumber}
                             dataKey='serialNumber'
                             nullText='(none)'/>
        </div>
        <div className='col-xs-2'>
          <EditableDatePicker onChange={this.handleChange}
                              value={this.props.equipment.warrantyDate}
                              dataKey='warrantyDate'
                              dateFormat='D MMMM YYYY'
                              editMode={this.props.editMode}/>
        </div>
        <div className='col-xs-2'>
          <EditableDatePicker onChange={this.handleChange}
                              value={this.props.equipment.installationDate}
                              dataKey='installationDate'
                              dateFormat='D MMMM YYYY'
                              editMode={this.props.editMode}/>
        </div>

        <div className='col-xs-1 tc'>
          <button className='btn btn-delete-equipment btn-default'
                  onClick={this.deleteEquipment}>
            <i className='fa fa-trash'/>
          </button>
        </div>
      </div>
    </div>;
  }
}

export default SystemDetails;
